import { useDispatch, useSelector } from 'react-redux';
import DefaultContainer from '../../container/default_container';
import './index.css';
import { useLink } from 'react-router-stack';
import React, { useEffect, useState } from 'react';
import {
  convertToDollars,
  formatWinningsForLeaderboard,
  getRealBalanceObj,
  isEligibleWalletBalance,
  isSmartPhone
} from '../../utilities/helper';
import constants from '../../constants';
import redirectPage from '../../hoc/redirect';
import MiniGamesConfirmationModal from '../../component/minigame_confirmation_modal';
import { CountdownTimer } from '../../component';
import { showErrorToast } from '../../actions/app-actions-types';
import useTheme from '../../utilities/hooks/theme';
import Constants from '../../constants';
// import LeaderboardMWeb from './index_mWeb';
const LeaderBoard = () => {
  const { MoreTheme: theme } = useTheme();
  const { gameDetails, gamesHistory = [] } = useSelector((state: any) => state.minigames);

  const { teamName = '' } = useSelector((state: any) => state.user);
  const [leaderBoard, setLeaderBoard] = useState([]);
  const [prizes, setPrizes]: any = useState({});
  const [confimationModal, setConfirmationModal] = useState(false);
  const [isGamePlayed, setIsGamePlayed] = useState(false);
  const { balanceInfo } = useSelector((state: any) => state.user);
  const balance: any = getRealBalanceObj(balanceInfo);
  const {
    gameSlug,
    leaderboard,
    contest,
    gameImageLandscape,
    gameName,
    gameImage,
    highScore = 0,
    currentScore = 0,
    gameType
  } = gameDetails;

  const { winningsPerPosition, winningsAmount, entryFee } = contest;
  const dispatch = useDispatch();
  useEffect(() => {
    const isGameInHistory =
      gamesHistory.filter((item: any) => item.gameName === gameDetails?.gameName).length > 0;
    setIsGamePlayed(isGameInHistory);
  }, []);
  useEffect(() => {
    const winningsPerPosition1 = winningsPerPosition['1'] || {}; //This represents winning amount in rupees
    const rupeesTemp: any = formatWinningsForLeaderboard(winningsPerPosition1);
    setPrizes({ ...rupeesTemp });
  }, [winningsPerPosition]);
  const navigate = useLink();
  const playAgainHandler = () => {
    if (isEligibleWalletBalance(balance['totalBalance'], entryFee)) {
      setConfirmationModal(true);
    } else {
      dispatch(showErrorToast('Insufficient Funds'));
    }
  };
  const playAnotherGameHandler = () => {
    navigate.push('/');
  };
  const processData = (rawData: any) => {
    let data: any = [];
    let drawData: any = {};
    for (let i = 0; i < rawData.length; i = i + 2) {
      const elem = rawData[i];
      const items = elem.split(':');
      const previousPlayer: any = i === 0 ? {} : data[data.length - 1];
      const currentRank = i / 2 + 1;
      const currentScore = rawData[i + 1];
      let rank;
      if (previousPlayer?.score === currentScore) {
        rank = previousPlayer?.rank;
        drawData[currentRank] = previousPlayer?.rank;
      } else {
        rank = currentRank;
      }
      const player = {
        name: items[1],
        score: currentScore,
        rank,
        playerId: items[0]
      };
      data.push(player);
    }
    setLeaderBoard(data.slice(0, 11));
  };
  useEffect(() => {
    processData([...leaderboard, `78787:${teamName}:0`, currentScore]);
  }, [leaderboard]);

  const onPressDismiss = () => {
    setConfirmationModal(false);
  };

  const onConfirmationHandler = () => {
    setConfirmationModal(false);
    navigate.push(`/games/${gameSlug}`);
  };

  const gameInfoContainerStyle = {
    background: theme.leaderBoardGameInfoBg,
    boxShadow: theme.leaderBoardGameInfoBoxShadow,
    border: `1px solid ${theme.leaderBoardGameInfoBorder}`
  };

  const playAgainContainerStyle = {
    background: theme.leaderBoardPlayAgainContainerBg,
    boxShadow: theme.leaderBoardPlayAgainContainerBoxShadow,
    border: `1px solid ${theme.leaderBoardPlayAgainContainerBorder}`
  };

  const playAgainBtnStyle = {
    background: theme.leaderBoardPlayAgainBtnBg,
    boxShadow: theme.leaderBoardPlayAgainBtnBoxShadow,
    border: `1px solid ${theme.leaderBoardPlayAgainBtnBorder}`
  };
  const playAnotherGameBtnStyle = {
    background: theme.leaderBoardPlayAnotherGameBtnBg,
    border: `1px solid ${theme.leaderBoardPlayAnotherGameBtnBorder}`,
    color: theme.leaderBoardPlayAnotherGameBtnColor
  };

  const tableContainerStyle = {
    border: `1px solid ${theme.leaderBoardTableBorder}`
  };

  const tableHeaderStyle = {
    background: theme.leaderBoardTableHeaderBg,
    boxShadow: theme.leaderBoardTableHeaderBoxShadow,
    color: theme.leaderBoardTableHeaderColor,
    borderBottom: `1px solid ${theme.leaderBoardTableBorder}`
  };

  const tableRowStyle1 = {
    background: theme.leaderBoardRowStyleBg
  };
  const tableRowStyle2 = {
    background: 'transparent'
  };

  const highScorePillStyle = {
    backgroundImage: `url(${constants.Images.highestScoreBorder})`
  };
  const currentScorePillStyle = {
    backgroundImage: `url(${constants.Images.currentScoreBorder})`
  };
  const highScorePillStyleMobile = {
    border: `1px solid ${theme.highestScorePillBorder}`
  };
  const currentScorePillStyleMobile = {
    border: `1px solid ${theme.currentScorePillBorder}`
  };
  const matchFlagStyle = {
    background: theme.minigamesMatchFlagBg,
    boxShadow: theme.minigamesMatchFlagBoxShadow,
    borderTop: 'solid 1px #3d4a5c',
    borderBottom: 'solid 1px #3d4a5c'
  };
  return (
    <DefaultContainer
      isWelcomeMessage={false}
      isNavigationHeader={isSmartPhone ? true : false}
      navigationTitle={isSmartPhone ? 'LeaderBoard' : ''}>
      <div className={isSmartPhone ? 'leaderboard__wrapper__mWeb ' : 'leaderboard_wrapper'}>
        {isSmartPhone ? (
          <div className={'leaderboard_container'}>
            <>
              <img
                className={isSmartPhone ? 'leaderboard_img_mWeb' : 'leaderboard_img'}
                src={gameImageLandscape}
              />
            </>
          </div>
        ) : (
          <div className="leaderboard_gameDetails_container_web">
            <div className="leaderboard_gameDetails_leftPart_web" style={gameInfoContainerStyle}>
              <img className="leaderboard_game_img_web" src={gameImage} />
              <div className="leaderboard_game_name_prize_container">
                <div className="leaderboard_game_name">{gameName}</div>
                <div className="leaderboard_seperator"></div>
                <div className="leaderboard_game_prize_container">
                  <img src={constants.Images.HourGlass} />
                  <CountdownTimer
                    style={{
                      fontSize: '22px',
                      fontWeight: '900',
                      color: 'white',
                      paddingLeft: '1%'
                    }}
                    isShowAlert={true}
                    matchItem={gameDetails}
                  />
                </div>
              </div>
            </div>
            <div className="leaderboard_gameDetails_rightPart_web " style={playAgainContainerStyle}>
              <img src={constants.Images.coin} width="20%" />

              <div className="leaderboard_keep_playing_txt">{`Keep Playing To Win ${convertToDollars(
                winningsAmount / 100
              )}`}</div>
              <button
                className="leaderboard_play_again_btn"
                style={playAgainBtnStyle}
                onClick={playAgainHandler}>
                Play Again
              </button>
              <button
                className="leaderboard_play_another_game_btn"
                style={playAnotherGameBtnStyle}
                onClick={() => navigate.push('/')}>
                Play Another Game
              </button>
            </div>
          </div>
        )}
        {isSmartPhone && <div className="leaderBoard__game__title__mWeb">{gameName}</div>}
        {isSmartPhone && (
          <div className="gameInfo__countdown__title__wrapper" style={matchFlagStyle}>
            <Constants.Svgs.HourGlass />
            <CountdownTimer isShowAlert={true} matchItem={gameDetails} />
          </div>
        )}
        {isGamePlayed && gameType !== 'playerVsPlayer' && isSmartPhone && (
          <div className="gameInfo__currentScore__highScore__wrapper__mWeb">
            <div
              className="gameInfo__currentScore__container__mWeb"
              style={currentScorePillStyleMobile}>
              <p className="gameInfo__currentScore__highScore__title__mWeb">Your Last Score</p>
              <div className="gameInfoScore__seperator__mWeb"></div>
              <p className="gameInfo__currentScore__highScore__score__mWeb">{currentScore}</p>
            </div>
            <div className="gameInfo__highScore__container__mWeb" style={highScorePillStyleMobile}>
              <p className="gameInfo__currentScore__highScore__title__mWeb">Your Highest Score</p>
              <div className="gameInfoScore__seperator__mWeb"></div>
              <p className="gameInfo__currentScore__highScore__score__mWeb">{highScore}</p>
            </div>
          </div>
        )}
        {!isSmartPhone && (
          <div className="leaderBoard__currentScore__highScore__wrapper__web">
            <div
              className="leaderBoard__currentScore__container__web"
              style={currentScorePillStyle}>
              <p className="leaderBoard__currentScore__highScore__title__web">Your Last Score</p>
              <div className="leaderBoardScore__seperator__web"></div>
              <p className="leaderBoard__currentScore__highScore__score__web">{currentScore}</p>
            </div>
            <div className="leaderBoard__highScore__container__web" style={highScorePillStyle}>
              <p
                className="leaderBoard__currentScore__highScore__title__web"
                style={{ marginRight: '5%' }}>
                Your Highest Score
              </p>
              <div className="leaderBoardScore__seperator__web"></div>
              <p className="leaderBoard__currentScore__highScore__score__web">{highScore}</p>
            </div>
          </div>
        )}

        <div
          className={
            isSmartPhone ? 'leaderboard_table_container_mWeb' : 'leaderboard_table_container'
          }
          style={tableContainerStyle}>
          <div
            className={`${
              isSmartPhone ? 'table_header_container__mWeb' : 'table_header_container'
            } row-center`}
            style={tableHeaderStyle}>
            <div className={`leaderboard_table_col1${isSmartPhone ? '__mWeb' : ''} row-center`}>
              Rank
            </div>
            <div className={`leaderboard_table_col2${isSmartPhone ? '__mWeb' : ''}`}> Player</div>
            <div className={`leaderboard_table_col3${isSmartPhone ? '__mWeb' : ''} row-center`}>
              Score
            </div>
            <div className={`leaderboard_table_col4${isSmartPhone ? '__mWeb' : ''} row-center`}>
              Can Win
            </div>
          </div>

          {leaderBoard.map((item: any, idx) => (
            <div
              className={`${
                isSmartPhone
                  ? 'leaderboard__table__row__container__mWeb'
                  : 'leaderboard_table_row_container'
              } ${item.name == teamName && 'highlighted_table_row'} ${
                idx === leaderBoard.length - 1 ? 'table_bottom_row' : ''
              }`}
              key={idx}
              style={idx % 2 == 0 ? tableRowStyle1 : tableRowStyle2}>
              <div className={`leaderboard_table_col1${isSmartPhone ? '__mWeb' : ''} row-center`}>
                {item.rank}.
              </div>
              <div className={`leaderboard_table_col2${isSmartPhone ? '__mWeb' : ''}`}>
                {item.name ? item.name : 'you'}
              </div>
              <div className={`leaderboard_table_col3${isSmartPhone ? '__mWeb' : ''} row-center`}>
                {item.name == teamName ? highScore : item.score}
              </div>
              <div className={`leaderboard_table_col4${isSmartPhone ? '__mWeb' : ''} row-center`}>
                <img src={constants.Images.coin} />
                <p>{`${convertToDollars(prizes[item.rank]?.value / 100)}`}</p>
              </div>
            </div>
          ))}
        </div>

        {isSmartPhone && (
          <React.Fragment>
            <div className={'leaderboard_play_game_container_mWeb'}>
              <div className="row-center" style={{ padding: '10px' }}>
                <img width={'20px'} src={constants.Images.coin} />
                <p>{`Keep Playing To Win ${convertToDollars(winningsAmount / 100)}`}</p>
              </div>
            </div>
            <div className="leaderboard_playBtns_wrapper__mWeb">
              <button
                className="leaderboard__play__btn__mWeb"
                style={playAgainBtnStyle}
                onClick={playAgainHandler}>
                play again
              </button>
              <button
                className="leaderboard_playAnotherGame_btn__mWeb"
                onClick={playAnotherGameHandler}>
                Play Another Game
              </button>
            </div>
          </React.Fragment>
        )}

        <MiniGamesConfirmationModal
          visible={confimationModal}
          onPressDismiss={onPressDismiss}
          EntryFee={entryFee}
          onConfirmationHandler={onConfirmationHandler}
        />
      </div>
    </DefaultContainer>
  );
};

export default redirectPage(LeaderBoard);
